// Auto-generated by cp-pdfjs.sh — do not edit
export const PDF_WORKER_SRC = 'assets/pdf.worker.min.b8c9a4c0.mjs';
export const PDF_WASM_URL = 'assets/wasm-1d2c115d/';
